import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './persuading.json';

const Persuading = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Persuasion techniques, rhetoric, and argumentation vocabulary. B2/C1 level grammar, reading, and speaking exercises."
            level="B2"
            title="Persuading"
            image="/Images/argue1.webp"
            seoTitle="Free English Lesson Plans: Persuading People"
            seoDescription="Persuasion techniques, rhetoric, and argumentation vocabulary. B2/C1 level grammar, reading, and speaking exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Persuading;


